module.exports = __webpack_public_path__ + "static/media/5.cdcb9136.jpg";